"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
exports.Time = {
    formatMMSS: function (seconds) {
        if (typeof seconds === "string")
            seconds = parseInt(seconds);
        var minutes = Math.trunc(seconds / 60);
        return this.formatXX(minutes) + ":" + this.formatXX(seconds - minutes * 60);
    },
    formatXX: function (seconds) {
        return "" + (seconds < 10 ? "0" : "") + seconds;
    }
};
